import { render } from "./user-avatar.vue?vue&type=template&id=6f9548b7&scoped=true"
import script from "./user-avatar.vue?vue&type=script&lang=js"
export * from "./user-avatar.vue?vue&type=script&lang=js"

import "./user-avatar.vue?vue&type=style&index=0&id=6f9548b7&lang=less&scoped=true"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9548b7"]])

export default __exports__